export default "__VITE_ASSET__CGvCMX2l__"